// extracted by mini-css-extract-plugin
module.exports = {"comment":"_6141","hd":"_3140","title":"_11959","more":"_8963","text":"_8794","arrow":"_5519","tags":"_5299","item":"_2244"};